import { useQuery } from '@tanstack/react-query';
import SuggestionsClient from 'flux/clients/suggestions';
import { ExperienceSource } from 'model/IExperience';
import { useCurrencyContext } from '~/context/CurrencyContext';

type UseSuggestionsArgs = {
  experienceId?: string;
  languageCode: string;
};

function useSuggestions({ experienceId, languageCode }: UseSuggestionsArgs) {
  const { state } = useCurrencyContext();
  const currency = state.currency;

  const { data, error, isFetching, isLoading } = useQuery<ExperienceSource[]>(
    ['suggestions', experienceId || '', languageCode, currency],
    () => {
      return SuggestionsClient.getById(experienceId, languageCode, currency);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      placeholderData: [],
      enabled: !!experienceId,
    },
  );

  return {
    data,
    error,
    loading: isLoading || isFetching,
  };
}

export default useSuggestions;
